import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
`;
export const Flag = styled.span`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    margin-right: 5px;
    display: inline-flex;
    img{
        width: 100%;
    }
`;